import React from 'react'
import 'antd/lib/switch/style/index.css'
import {
	Row, Col, Tooltip
}from 'antd'
import '../style.css'
import moment from "moment"
import ResolutionResultFiles from '../../AppealFiles/ResolutionResultFiles'
import SignedIcon from "../../../../../public/signedIcon.png"
import i18n from './localization'

const ResolutionResult  = (props) => {
	const {
		resolutionResult, isRu, key, showSignerInfo
	} = props

	return (
        <Row
        className="result-appeal"
        justify="center"
        key={key}
        >
        <Col className="header-result-appeal">
            <span className='header-result'>
                <span className='header-title'>
                    { 
                        (resolutionResult.isSummaryResult || !showSignerInfo 
                         ? i18n.ResolutionResultWithDate[isRu]
                         : i18n.IntermediateResolutionResultWithDate[isRu]).format(moment(resolutionResult.creationDate).format("DD.MM.YYYY"))
                    }
                </span>
                <span>
                    {resolutionResult.signerInfo && showSignerInfo &&
                        <Tooltip 
                            title={i18n.signer[isRu].format(resolutionResult.signerInfo)}
                            overlayInnerStyle={{ whiteSpace: 'pre-line' }}
                            className='signed_icon'
                        >
                            <img src={SignedIcon} />
                        </Tooltip>
                    }
                </span>
            </span>
        </Col>
        <Col className="body-result-appeal">
            { `\t${resolutionResult.response}` }
        </Col>
        <Col className="files-body-info-appeal">
            <ResolutionResultFiles
                isRu={ isRu }
                resolutionResultFiles = {resolutionResult.resultFiles}
                isSummaryResult = {resolutionResult.isSummaryResult}
                showSignerInfo = {showSignerInfo}
            /> 
        </Col>
    </Row>
    )
}

export default ResolutionResult
